// NarodeninySmsTab.jsx — NARODENINY_SMS_V1 (Mirko 21. 10. 2026, Kronika 2566): Nastavenia › Narodeninové SMS
// Texty na rok podľa jazyka (mení vedenie), zapnutie, oslávenci na 30 dní a čo im chýba, história odoslaných.
import React, { useEffect, useState, useCallback } from 'react'
import { fetchAuth } from '../auth/fetchAuth.js'
import { COLORS, TYPO, SPACE, RADIUS } from '../theme.js'

const inp = { width: '100%', padding: '8px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontFamily: 'inherit', fontSize: 13, boxSizing: 'border-box' }
const bunka = { padding: '5px 8px', borderBottom: `1px solid ${COLORS.line}`, fontSize: TYPO.sizes.sm, textAlign: 'left', verticalAlign: 'top' }
const fmtD = d => { const m = String(d || '').match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? (+m[3]) + '. ' + (+m[2]) + '. ' + m[1] : String(d || '') }

export default function NarodeninySmsTab() {
  const [d, setD] = useState(null)
  const [texty, setTexty] = useState({})
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState('')
  const load = useCallback(() => {
    fetchAuth('/api/narodeniny/prehlad').then(r => r.json().then(j => ({ ok: r.ok, j }))).then(({ ok, j }) => { if (!ok) { setD({ chyba: j.error }); return } setD(j); setTexty(j.texty || {}) }).catch(() => setD({ chyba: 'Nedá sa načítať' }))
  }, [])
  useEffect(() => { load() }, [load])
  async function uloz(extra) {
    setBusy(true); setMsg('')
    try {
      const r = await fetchAuth('/api/narodeniny/nastavenie', { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(extra || { texty }) })
      const j = await r.json().catch(() => ({}))
      setMsg(r.ok ? 'Uložené' + (j.zmeny && j.zmeny.length ? ': ' + j.zmeny.join(', ') : '') : (j.error || 'Uloženie zlyhalo'))
      load()
    } finally { setBusy(false) }
  }
  if (!d) return <div style={{ color: COLORS.muted }}>Načítavam…</div>
  if (d.chyba) return <div style={{ color: '#B91C1C' }}>{d.chyba}</div>
  const ro = !d.smie_menit
  return (
    <div style={{ maxWidth: 900, display: 'flex', flexDirection: 'column', gap: SPACE.lg }}>
      <div style={{ fontSize: 13, color: COLORS.muted }}>
        Každý deň o <b>{d.cas}</b> (slovenský čas) dostane SMS každý aktívny zamestnanec, ktorý má v ten deň narodeniny — dátum narodenia a telefón sa berú z karty, jazyk podľa národnosti. Jeden človek dostane jednu SMS za rok. {d.od && d.dnes < d.od ? 'Prvé odosielanie: ' + fmtD(d.od) + '.' : ''}
      </div>
      <label style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 14, fontWeight: 700 }}>
        <input type="checkbox" checked={!!d.zapnute} disabled={ro || busy} onChange={e => uloz({ zapnute: e.target.checked })} /> Odosielať narodeninové SMS
      </label>
      <div>
        <div style={{ fontWeight: 800, marginBottom: 6 }}>Texty na tento rok</div>
        {Object.entries(d.jazyky).map(([j, nazov]) => (
          <div key={j} style={{ marginBottom: 10 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 3 }}>{nazov}{j === 'uk' ? ' — ide v cyrilike' : ' — odíde bez diakritiky ako každá SMS'}</div>
            <textarea value={texty[j] || ''} disabled={ro} rows={2} onChange={e => setTexty(t => ({ ...t, [j]: e.target.value }))} style={{ ...inp, resize: 'vertical' }} />
          </div>
        ))}
        {!ro && <button type="button" disabled={busy} onClick={() => uloz()} style={{ padding: '7px 16px', border: 'none', background: '#1D4ED8', color: '#fff', borderRadius: RADIUS.md, cursor: 'pointer', fontFamily: 'inherit', fontWeight: 700 }}>Uložiť texty</button>}
        {msg && <span style={{ marginLeft: 10, fontSize: 13, color: COLORS.muted }}>{msg}</span>}
      </div>
      <div>
        <div style={{ fontWeight: 800, marginBottom: 6 }}>Najbližších 30 dní</div>
        <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 6 }}>Z {d.aktivnych} aktívnych nemá {d.bez_datumu} dátum narodenia a {d.bez_telefonu} telefón — tí SMS nedostanú (dátum narodenia sa dá prevziať z MKsoftu na karte › Z MKsoftu).</div>
        {d.oslavenci.length === 0 ? <div style={{ fontSize: 13, color: COLORS.muted }}>Nikto.</div> : (
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead><tr>{['Dátum', 'Zamestnanec', 'Vek', 'Jazyk', 'Telefón'].map(h => <th key={h} style={{ ...bunka, color: COLORS.muted }}>{h}</th>)}</tr></thead>
            <tbody>{d.oslavenci.map(o => <tr key={o.datum + o.id}><td style={bunka}>{fmtD(o.datum)}</td><td style={bunka}>{o.meno}</td><td style={bunka}>{o.vek}</td><td style={bunka}>{d.jazyky[o.jazyk]}</td><td style={{ ...bunka, color: o.telefon ? '#15803D' : '#B91C1C' }}>{o.telefon ? 'áno' : 'chýba — SMS nepôjde'}</td></tr>)}</tbody>
          </table>
        )}
      </div>
      <div>
        <div style={{ fontWeight: 800, marginBottom: 6 }}>Odoslané</div>
        {d.historia.length === 0 ? <div style={{ fontSize: 13, color: COLORS.muted }}>Zatiaľ nič.</div> : (
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead><tr>{['Dátum', 'Zamestnanec', 'Jazyk', 'Výsledok'].map(h => <th key={h} style={{ ...bunka, color: COLORS.muted }}>{h}</th>)}</tr></thead>
            <tbody>{d.historia.map(h => <tr key={h.id}><td style={bunka}>{fmtD(h.datum)}</td><td style={bunka}>{h.meno || h.employee_id}</td><td style={bunka}>{d.jazyky[h.jazyk] || h.jazyk}</td><td style={{ ...bunka, color: h.vysledok === 'odoslane' ? '#15803D' : '#B91C1C' }}>{h.vysledok === 'odoslane' ? 'odoslané' : (h.chyba || h.vysledok)}</td></tr>)}</tbody>
          </table>
        )}
      </div>
    </div>
  )
}
